module.exports = __webpack_public_path__ + "img/main_image2.d173b233.png";